// extracted by mini-css-extract-plugin
module.exports = {"Step2":"Step2_Step2__106Oo","Option":"Step2_Option__3Re5t","textContainer":"Step2_textContainer__2wAOO","or":"Step2_or__8hexl"};